<div class="flex flex-wrap max-w-7xl mx-auto mt-8">

    <div class="w-full flex justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        @if((myRoles$ | async)?.admin && (group$ | async)?.memberStatus ==
        membershipStatus.active
        ) {
        <app-btn-route btnText="Add Prayer" routeTo="create" icon="fa fa-add"
            colors="bg-primary-500 hover:bg-primary-300"></app-btn-route>
        }
    </div>

    <h1 class="font-semibold text-2xl text-primary-500 mb-4">
        Prayers
    </h1>

    @let group = group$ | async;
    @let prayerStatsLoading = prayerStatsLoading$ | async;

    @if (group) {
    <!-- Metrics forced in a single row on all devices using grid-cols-3 and responsive font sizing -->
    <div class="grid grid-cols-3 gap-2 md:gap-4 w-full mb-4">
        <div class="w-full bg-white rounded-lg shadow-lg px-4 py-2 flex flex-col items-start justify-between gap-1">
            <span class="w-full text-start text-xs md:text-sm text-blueGray-400">Active Prayers</span>
            @if (prayerStatsLoading) {
            <div class="animate-pulse h-8 w-1/2 bg-slate-200 rounded-lg"></div>
            } @else {
            <div class="flex flex-row justify-start gap-1 content-center">
                <span class="w-full text-3xl md:text-5xl font-bold text-primary-500">{{group.activePrayers ??
                    '-'}}</span>
            </div>
            }
        </div>
        <div class="w-full bg-white rounded-lg shadow-lg px-4 py-2 flex flex-col items-start justify-between gap-1">
            <span class="w-full text-start text-xs md:text-sm text-blueGray-400">Opened/Closed (30 days)</span>
            @if (prayerStatsLoading) {
            <div class="animate-pulse h-8 w-1/2 bg-slate-200 rounded-lg"></div>
            } @else {
            <div class="flex flex-row justify-start gap-1 content-center">
                <span class="w-full text-3xl md:text-5xl font-bold text-primary-500">{{group.openedPrayers ??
                    '-'}}</span>
                <span class="text-3xl md:text-5xl font-bold text-primary-200 inline">/</span>
                <span class="w-full text-3xl md:text-5xl font-bold text-primary-500 inline">{{group.closedPrayers ??
                    '-'}}</span>
            </div>
            }
        </div>
        <div class="w-full bg-white rounded-lg shadow-lg px-4 py-2 flex flex-col items-start justify-between gap-1">
            <span class="w-full text-start text-xs md:text-sm text-blueGray-400 block">Requested (30 days)</span>
            @if (prayerStatsLoading) {
            <div class="animate-pulse h-8 w-1/2 bg-slate-200 rounded-lg"></div>
            } @else {
            <div class="flex flex-row justify-start gap-1 content-center">
                <span class="w-full text-3xl md:text-5xl font-bold text-primary-500">{{group.requestedPrayers ??
                    '-'}}</span>
            </div>
            }
        </div>
    </div>
    }

    <div class="w-full my-4">
        <div class="w-full flex flex-col gap-4">
            @for (item of prayers$ | async; track item.id) {
            <div class="bg-white shadow-lg rounded-lg w-full px-4 py-3 cursor-default flex flex-row items-start">
                <div class="flex flex-col items-start w-full">
                    <div class="flex flex-row justify-between items-start w-full gap-4">
                        <div class="flex flex-col w-full">
                            <!-- Timestamp and Chip status placed right next to each other (vertically centered) -->
                            <div class="flex flex-row items-center gap-2 mb-1.5">
                                <span class="text-primary-300 text-xs whitespace-nowrap leading-none">
                                    {{item.modified!.toDate() | moment: 'Do MMM YYYY hh:mm a'}}
                                </span>
                                <app-chip class="inline-flex items-center" [label]="item.status"
                                    [color]="chipColors[item.status]" padding="px-2 py-0.5"
                                    fontSize="text-[10px]"></app-chip>
                                <app-chip class="inline-flex items-center" label="#{{item.category}}"
                                    padding="px-2 py-0.5" fontSize="text-[10px]"></app-chip>
                            </div>
                            <a [routerLink]="[item.id]"
                                class="cursor-pointer font-semibold text-blueGray-600 hover:text-primary-500 leading-snug break-words">
                                {{item.subject}}
                            </a>
                        </div>
                        <!-- Admin Edit & Delete action buttons on the right corner -->
                        @if ((myRoles$ | async)?.admin && group?.memberStatus == membershipStatus.active) {
                        <div class="flex flex-row gap-2 whitespace-nowrap flex-none">
                            <app-btn-fab (click)="onEdit(item)" icon="fas fa-edit" tooltip="Edit"></app-btn-fab>
                            <app-btn-fab (click)="onDelete(item)" icon="fa fa-trash-can"
                                textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                        </div>
                        }
                    </div>
                    @if (item.description) {
                    <p class="text-xs text-blueGray-400 font-light mt-2 line-clamp-3 break-words w-full">
                        {{item.description}}
                    </p>
                    }
                </div>
            </div>
            } @empty {
            @if (!(prayersLoading$ | async)) {
            <div
                class="bg-white shadow-lg rounded-lg w-full px-6 py-4 text-center font-semibold border-0 text-blueGray-500">
                No Prayers Found
            </div>
            }
            }
            @if (prayersLoading$ | async) {
            <div class="bg-white shadow-lg rounded-lg w-full px-4 py-3 flex flex-row items-start animate-pulse">
                <div class="flex flex-col items-start w-full space-y-2">
                    <div class="h-3 bg-slate-200 rounded w-1/4"></div>
                    <div class="h-4 bg-slate-200 rounded w-3/4"></div>
                    <div class="h-3 bg-slate-200 rounded w-full mt-2"></div>
                </div>
            </div>
            }
        </div>
    </div>
    @if (prayers$ | async) {
    <div class="flex flex-row w-full justify-center px-4 pb-2">
        <app-btn-more (click)="addMore()" [isDisabled]="(prayersLoading$ | async) ?? false"
            [inProgress$]="prayersLoading$"></app-btn-more>
    </div>
    }
</div>